export default __webpack_public_path__ + "static/media/TrendFlat.50b9d282.svg";